<template>
  <div>
      <vx-card>
        <div v-if="is_skeleton">
          <a-skeleton active />
        </div>
        <div v-else class="flex space-x-4">
          <a-avatar shape="square" icon="user" />
          <div class="self-center font-semibold text-xl	">{{ contact.person ? contact.person.first_name + ' ' + contact.person.last_name : contact.company.name + '(Company)' }}</div>
        </div>
      </vx-card>
      <vx-card class="mt-5">
        <a-tabs default-active-key="1" @tabClick="tabClick" :tabBarStyle="{width: '99%',margin: 'auto'}">
          <a-tab-pane key="1" tab="Dashboard" force-render>
            <div class="grid grid-cols-1 md:grid-cols-2 md:gap-4 mx-auto my-5" style="width: 99%">
              <a-card title="Contact information">
                <div v-if="is_skeleton">
                  <a-skeleton active />
                </div>
                <a-descriptions :column="1" v-else>
                  <a-descriptions-item label="Phone" >
                    <template class="mt-5" v-if="contact.phones.length" v-for="phone in contact.phones.slice(0,3)">
                      <a :href="`tel:${phone.phone_number}`"> {{ phone.phone_number }}</a>
                    </template>
                  </a-descriptions-item>
                  <a-descriptions-item label="Email">
                    <template class="mt-5" v-if="contact.emails.length" v-for="email in contact.emails.slice(0,3)">
                      <a :href="`mailto:${email.email_address}`">{{ email.email_address }}</a>
                    </template>
                  </a-descriptions-item>
                  <a-descriptions-item label="Website" >
                    <template class="mt-5" v-for="website in contact.websites.slice(0,3)">
                      <a :href="website.website_address">{{ website.website_address }}</a>
                    </template>
                  </a-descriptions-item>
                  <a-descriptions-item label="Address">
                    <template class="mt-5" v-for="address in contact.addresses">
                      <ATag>{{ address.street }}</ATag>
                    </template>
                  </a-descriptions-item>
                </a-descriptions>
              </a-card>
              <a-card title="Client's matters">
                <div v-if="is_skeleton">
                  <a-skeleton active />
                </div>
                <div v-else class="flex justify-between flex-row" :class="[matters.indexOf(matter) > 0 ? 'mt-5' : '']" v-for="(matter,ind) in matters">
                  <div><a-button type="link" class="p-0">{{ matter.title }}</a-button>: {{ matter.description }} <ATag :color="statusMatter(matter.status).color">{{ statusMatter(matter.status).title }}</ATag></div>
                  <div>
                    <a-dropdown>
                      <a-menu slot="overlay">
                        <a-menu-item key="1" @click="$router.push(`/matters/edit/${matter.id}`)"><feather-icon icon="EditIcon" svg-classes="text-success w-4 h-4" class="pr-2"/>Edit</a-menu-item>
                      </a-menu>
                      <a-button style="margin-left: 8px;border-radius: 3px !important;"> Action <a-icon type="down" /></a-button>
                    </a-dropdown>
                  </div>
                </div>
              </a-card>
            </div>
          </a-tab-pane>
          <a-tab-pane key="2" tab="Matters" force-render>
            <ListMatter ref="matter" class="mx-auto my-5"/>
          </a-tab-pane>
          <a-tab-pane key="3" tab="Documents" force-render>
            <ListDocument ref="document" class="mx-auto my-5"/>
          </a-tab-pane>
          <a-tab-pane key="4" tab="Notes" force-render>
            <ListNotes ref="note" class="mx-auto my-5" style="width: 99%"/>
          </a-tab-pane>
          <a-tab-pane key="5" tab="Bills" force-render>
            <ListBilling ref="bill" class="mx-auto my-5" style="width: 99%"/>
          </a-tab-pane>
<!--          <a-tab-pane key="6" tab="Transactions" force-render>-->
<!--            <ListHistoryContact ref="transaction" class="mx-auto my-5" style="width: 99%"/>-->
<!--          </a-tab-pane>-->
        </a-tabs>
      </vx-card>
  </div>
</template>

<script>
  import axios from "@/axios";
  import ListMatter from "./ListMatterContact";
  import ListDocument from "./ListDocumentContact";
  import ListNotes from "./ListNotesContact";
  import ListBilling from "./ListBillingContact";
  import ListHistoryContact from "./ListHistoryContact";

  export default {
    name: "DashboardContact",
    components:{
      ListMatter,
      ListDocument,
      ListNotes,
      ListBilling,
      ListHistoryContact
    },
    data(){
      return{
        contact: {},
        matters : [],
        bills: [],
        is_skeleton: false
      }
    },
    methods:{
      tabClick(value){

      },
      async getDashboardContact(){
        try{
          this.is_skeleton = true
          const contact_id = this.$store.state.dashboard_contact_id  || this.$route.params.id
          const { data } = await axios.get(`/contact/${contact_id}/`)
          this.contact = data
        }catch (e){
          this.$message.error('Error receiving information')
          this.$router.push('/contacts').then(()=>{})
        }finally {
          this.is_skeleton = false
        }
      },
      async getMatter(){
        try{
          this.is_skeleton = true
          const contact_id = this.$store.state.dashboard_contact_id || this.$route.params.id
          const { data } = await axios.post('/matter/query/',{limit:999, query: [{field:"client__id", condition: "=", value : contact_id}]})
          this.matters = data.rows
        }catch (e) {
          this.$message.error('Error receiving information')
          this.$router.push('/contacts').then(()=>{})
        }finally {
          this.is_skeleton = false
        }
      },
      async getBills(){
        try{
          this.is_skeleton = true
          const contact_id = this.$store.state.dashboard_contact_id || this.$route.params.id
          const { data } = await axios.post('/billing/query/',{limit:999, query: [{field:"to_contact", condition: "=", value : contact_id}]})
          this.bills = data.rows
        }catch (e) {
          this.$message.error('Error receiving information')
          this.$router.push('/contacts').then(()=>{})
        }finally {
          this.is_skeleton = false
        }
      },
      statusMatter(sts){
        if(sts === 1)
          return {title:'Open',color:'green'}
        else if(sts === 2)
          return {title:'Close',color: 'red'}
        else if(sts === 3)
          return {title:'Pending',color:'yellow'}
      }
    },
    created() {
      this.$store.state.dashboard_contact_id = this.$route.params.id
      this.getDashboardContact()
      this.getMatter()
      // this.getBills()
    },
    beforeDestroy() {
      this.$store.commit('DASHBOARD_ID',null)
    }
  }
</script>

<style>
  [dir] .ant-tag{
    border-radius: 3px !important;
  }
  [dir] .ant-card-head{
    width: 100%;
  }
</style>
